<template>
  <b-breadcrumb class="ml-auto mr-auto mt-5" :items="items"></b-breadcrumb>
</template>

<script>
export default {
  name: 'Breadcrumbs',
  props: ['route'],
  computed: {
    items () {
      switch (this.route.name) {
        case 'apiaries':
          return []
        case 'apiary_create':
          return [
            {
              text: this.$t('apiaries.title'),
              to: '/apiaries'
            },
            {
              text: this.$t('apiary_create.title'),
              to: this.route.path,
              active: true
            }
          ]
        case 'apiary_edit':
          return [
            {
              text: this.$t('apiaries.title'),
              to: '/apiaries'
            },
            {
              text: this.$t('apiary_edit.title'),
              to: this.route.path,
              active: true
            }
          ]
        case 'apiary':
          return [
            {
              text: this.$t('apiaries.title'),
              to: '/apiaries'
            },
            {
              text: this.$t('apiary.title'),
              to: this.route.path,
              active: true
            }
          ]
        case 'colony_create':
          return [
            {
              text: this.$t('apiaries.title'),
              to: '/apiaries'
            },
            {
              text: this.$t('apiary.title'),
              to: '/apiary/' + this.route.params.apiary
            },
            {
              text: this.$t('colony_create.title'),
              to: this.route.path,
              active: true
            }
          ]
        case 'colony_edit':
          return [
            {
              text: this.$t('apiaries.title'),
              to: '/apiaries'
            },
            {
              text: this.$t('apiary.title'),
              to: '/apiary/' + this.route.params.apiary
            },
            {
              text: this.$t('colony_edit.title'),
              to: this.route.path,
              active: true
            }
          ]
        case 'colony':
          return [
            {
              text: this.$t('apiaries.title'),
              to: '/apiaries'
            },
            {
              text: this.$t('apiary.title'),
              to: '/apiary/' + this.route.params.apiary
            },
            {
              text: this.$t('colony.title'),
              to: this.route.path,
              active: true
            }
          ]
        case 'queen_create':
          return [
            {
              text: this.$t('apiaries.title'),
              to: '/apiaries'
            },
            {
              text: this.$t('apiary.title'),
              to: '/apiary/' + this.route.params.apiary
            },
            {
              text: this.$t('colony.title'),
              to: '/colony/' + this.route.params.colony + '/' + this.route.params.apiary
            },
            {
              text: this.$t('queen_create.title'),
              to: this.route.path,
              active: true
            }
          ]
        case 'queen_edit':
          return [
            {
              text: this.$t('apiaries.title'),
              to: '/apiaries'
            },
            {
              text: this.$t('apiary.title'),
              to: '/apiary/' + this.route.params.apiary
            },
            {
              text: this.$t('colony.title'),
              to: '/colony/' + this.route.params.colony + '/' + this.route.params.apiary
            },
            {
              text: this.$t('queen_edit.title'),
              to: this.route.path,
              active: true
            }
          ]
        case 'queen':
          return [
            {
              text: this.$t('apiaries.title'),
              to: '/apiaries'
            },
            {
              text: this.$t('apiary.title'),
              to: '/apiary/' + this.route.params.apiary
            },
            {
              text: this.$t('colony.title'),
              to: '/colony/' + this.route.params.colony + '/' + this.route.params.apiary
            },
            {
              text: this.$t('queen.title'),
              to: this.route.path,
              active: true
            }
          ]
        case 'unite_colonies_or_remove_queen':
        case 'unite_colonies_or_remove_queen2':
        case 'unite_colonies':
          return [
            {
              text: this.$t('apiaries.title'),
              to: '/apiaries'
            },
            {
              text: this.$t('apiary.title'),
              to: '/apiary/' + this.route.params.apiary
            },
            {
              text: this.$t('colony.title'),
              to: '/colony/' + this.route.params.colony + '/' + this.route.params.apiary
            },
            {
              text: this.$t('unite_colonies_or_remove_queen.title'),
              active: true
            }
          ]
        case 'unite_colonies_or_remove_queen3':
          return [
            {
              text: this.$t('apiaries.title'),
              to: '/apiaries'
            },
            {
              text: this.$t('apiary.title'),
              to: '/apiary/' + this.route.params.apiary
            },
            {
              text: this.$t('colony.title'),
              to: '/colony/' + this.route.params.colony + '/' + this.route.params.apiary
            },
            {
              text: this.$t('unite_colonies_or_remove_queen3.title'),
              active: true
            }
          ]
        case 'rating_archive':
          return [
            {
              text: this.$t('apiaries.title'),
              to: '/apiaries'
            },
            {
              text: this.$t('apiary.title'),
              to: '/apiary/' + this.route.params.apiary
            },
            {
              text: this.$t('colony.title'),
              to: '/colony/' + this.route.params.id + '/' + this.route.params.apiary
            },
            {
              text: this.$t('rating_archive.title'),
              active: true
            }
          ]
        default:
          return []
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../scss/config';

  .breadcrumb {
    font-family: $font-family-sans-serif;
  }
</style>
